//!#system	

<template>
	<v-app>
		<v-layout fill-height>
			<v-navigation-drawer permanent>
				<v-list-item>
					<v-list-item-content>
						<v-list-item-title class="title">
							Settings
						</v-list-item-title>
						<v-list-item-subtitle>
							App settings and tools
						</v-list-item-subtitle>
						<v-text-field v-model="searchString" label="Find settings..." :clearable="true" />
					</v-list-item-content>
				</v-list-item>

				<div v-if="isLoading">
					<v-skeleton-loader
						v-for="itemGroup in itemGroups" :key="itemGroup.namespace"
						type="list-item-avatar, divider"
					></v-skeleton-loader>
				</div>

				<v-list class="pt-0" dense nav v-for="itemGroup in itemGroups" :key="itemGroup.namespace" v-if="!isLoading && itemGroup.items.length > 0">
					<v-divider v-if="itemGroup.items.length > 0"></v-divider>
					<v-list-item v-for="item in itemGroup.items" :key="item.friendly.pluralName" :disabled="!toLink(item)" :to="toLink(item)">
						<v-list-item-icon>
							<v-icon class="iconWidth">{{ item.icon }}</v-icon>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title>{{ item.friendly.pluralName }}</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</v-list>
				
			</v-navigation-drawer>
			
			<v-flex xs10>
				<keep-alive>
					<router-view></router-view>
				</keep-alive>
			</v-flex>

		</v-layout>
	</v-app>
</template>

<script>
import store from '@/store';
import apiService from '@/apiService';
import series from 'to-series';
export default {
	data() {
		return {
			drawer: true,
			searchString: '',
			items: [{"name":"emailTemplate","pluralName":"emailTemplates","namespace":"comms","icon":"mdi-email-edit-outline","colorVariant":"blue-grey darken-3","description":"The email templates that turn data objects into HTML content.","singleton":"","friendly":{"name":"Email Template","pluralName":"Email Templates"},"path":"email-templates","prefix":"EmailTemplate","dashedNamespace":"comms"},{"name":"queuedEmail","pluralName":"queuedEmails","namespace":"comms","icon":"mdi-send","colorVariant":"blue-grey darken-3","description":"Emails that the app sends get queued for sending though a SMTP provider.","singleton":"","friendly":{"name":"Queued Email","pluralName":"Queued Emails"},"path":"queued-emails","prefix":"QueuedEmail","dashedNamespace":"comms"},{"name":"queue","pluralName":"queues","namespace":"system","icon":"mdi-layers-triple","colorVariant":"blue-grey darken-3","description":"The types of queues that things can be added to.","singleton":"","friendly":{"name":"Queue","pluralName":"Queues"},"path":"queues","prefix":"Queue","dashedNamespace":"system"},{"name":"group","pluralName":"groups","namespace":"uac","icon":"mdi-account-group","colorVariant":"light-blue darken-4","description":"Groups organize your users for permissions/access.","singleton":"","friendly":{"name":"Group","pluralName":"Groups"},"path":"groups","prefix":"Group","dashedNamespace":"uac"},{"name":"invite","pluralName":"invites","namespace":"uac","icon":"mdi-account-plus-outline","colorVariant":"light-blue darken-4","description":"Invitations for users to register.","singleton":"","friendly":{"name":"Invite","pluralName":"Invites"},"path":"invites","prefix":"Invite","dashedNamespace":"uac"},{"name":"user","pluralName":"users","namespace":"uac","icon":"mdi-account","colorVariant":"light-blue darken-4","description":"Users are the people and bots that are registered in your account.","singleton":"","friendly":{"name":"User","pluralName":"Users"},"path":"users","prefix":"User","dashedNamespace":"uac"},{"name":"location","pluralName":"locations","namespace":"dist","icon":"mdi-office-building","colorVariant":"indigo darken-3","description":"The different locations that we hold distributions.","top":false,"singleton":"","defaultListQuery":"","friendly":{"name":"Location","pluralName":"Locations"},"path":"locations","prefix":"Location","dashedNamespace":"dist"},{"name":"preMap","pluralName":"preMaps","namespace":"people","icon":"mdi-history","colorVariant":"indigo darken-3","description":"Historical card-codes and email addresses from the previous system.","top":false,"singleton":"","defaultListQuery":"","friendly":{"name":"Pre Map","pluralName":"Pre Maps"},"path":"pre-maps","prefix":"PreMap","dashedNamespace":"people"},{"name":"school","pluralName":"schools","namespace":"people","icon":"mdi-account-school","colorVariant":"indigo darken-3","description":"The schools that children attend in our areas.","top":false,"singleton":"","defaultListQuery":"","friendly":{"name":"School","pluralName":"Schools"},"path":"schools","prefix":"School","dashedNamespace":"people"}],
			mini: true,
			right: null,
			links: {},
			isLoading: false
		}
	},
	computed: {
		itemGroups: function() {
			let grouped = [], pos = ['uac'];
			grouped.push({ namespace: 'uac', items: [] }); // user admin first
			this.items.forEach(item => {
				let p = pos.indexOf(item.namespace);
				if (p === -1) {
					pos.push(item.namespace);
					p = pos.indexOf(item.namespace);
					grouped.push({ namespace: item.namespace, items: [] });
				}
			});

			grouped.forEach(group => {
				group.items = this.items.filter(item => item.namespace === group.namespace && (!this.searchString || (this.searchString && item.name.toLowerCase().includes(this.searchString.toLowerCase()))));
			});

			return grouped;
		}
	},
	methods: {
		toLink(item) {
			return this.links[item.dashedNamespace + '/' + item.path];
		},
		getInitialData() {
			this.isLoading = true;
			series()
				.each(this.items, (item, cb) => {
					if (!item.singleton) {
						this.links[item.dashedNamespace + '/' + item.path] = '/app/settings/' + item.dashedNamespace + '/' + item.path;
						return cb();
					}
					if (this.$store.state.app.contextLinks[item.dashedNamespace + '/' + item.path]) {
						this.links[item.dashedNamespace + '/' + item.path] = this.$store.state.app.contextLinks[item.dashedNamespace + '/' + item.path];
						return cb();
					}
					apiService.list({
						namespace: item.namespace,
						pluralName: item.pluralName
					}, (err, response, meta) => {
						if (err) {
							this.$store.dispatch('app/applyObjectError', {
								show: true,
								text: meta.validation ? meta.validation.messages.join('\n') : err
							});
						} else if (response.length <= 0) {
							this.$store.dispatch('app/applyObjectError', {
								show: true,
								text: 'Unable to locate this setting...'
							});
						} else {
							this.links[item.dashedNamespace + '/' + item.path] = '/app/settings/' + item.dashedNamespace + '/' + item.path + '/detail/' + encodeURIComponent(response[0].id);
							this.$store.dispatch('app/cacheContextLink', {
								key: item.dashedNamespace + '/' + item.path,
								link: this.links[item.dashedNamespace + '/' + item.path]
							});
						}
						return cb();
					});
				})
				.end(err => {
					this.isLoading = false;
				});
		}
	},
	beforeRouteLeave(to, from, next) {
		// called when the route that renders this component is about to
		// be navigated away from.
		// has access to `this` component instance.
		//console.log('Settings:beforeRouteLeave', to, from);
		if (store.state.app.mainDrawer===false) {
			//this.$store.dispatch('app/toggleDrawer');
		}
		return next();
	},
	created() {
		this.getInitialData();
	}
}
</script>

<style scoped>
.v-list-item__title {
  font-family: "Poppins"!important;
}
.iconWidth {
	width: 30px;
}
</style>